import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Semantic breadcrumbs with aria-label + schema-friendly markup.
// Pair with `breadcrumbSchema(items)` in the page's <SEO /> JSON-LD.
export const Breadcrumbs = ({ items = [] }) => (
  <nav
    aria-label="Breadcrumb"
    data-testid="breadcrumbs"
    className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-32"
  >
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs md:text-sm font-mono uppercase tracking-[0.15em]">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={it.path} className="flex items-center gap-2">
            {i > 0 && <ChevronRight size={12} className="text-[#999999]" aria-hidden />}
            {last ? (
              <span aria-current="page" className="text-[#111111]">
                {it.name}
              </span>
            ) : (
              <Link to={it.path} className="text-[#999999] hover:text-[#111111] transition-colors">
                {it.name}
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
